import { useEffect, useState } from 'react';
import { loadLegacyAvailability } from '../util/legacyAnalytics';

/** True once the account is known to have legacy patients; false until then. */
export function useLegacyAvailability() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    loadLegacyAvailability().then((value) => {
      if (!cancelled) setAvailable(value);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return available;
}
